import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ResourceFormService, ResourceListPane } from '@smartsoftware/reflex-core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ReflexEnvironment as environment } from '@smartsoftware/reflex-core';

import {
    WIP,
    Document,
    Order,
    OrderStatus,
    Order_Service,
    UserPermission_Service,
    OrderHistoryUserFilter,
    SuccessOrderDataSource,
    PagedResourceListComponent,
    Division,
    SuccessAccountPermissionNodeName,
    SystemConfig_service,
    ServiceType,
    ServiceCategory,
    Service_Service,
    Service,
    ServiceAddress_Service,
    ServiceAddress,
    Telemetry_Service,
    TelemetryEventType,
    VendorAccount_Service,
    VendorAccount,
    UserDevicePreferencesService
} from 'legalreflex-lib';
import { animate, trigger, state, style, transition } from '@angular/animations';
import { FormGroup, FormBuilder, FormControl, AbstractControl } from '@angular/forms';
import { BreadCrumbService } from '../../../components/breadcrumb-bar/breadcrumb-service';
import { Title } from '@angular/platform-browser';
import { SelectVendorAccountDialog } from '../../../components/selectVendorAccount/selectVendorAccount';
import { BehaviorSubject, of, Subject } from 'rxjs';
import { filter, map, switchMap, takeUntil } from 'rxjs/operators';

// moved Division enum to vendor model 
// const enum Division {
//     DATATRAC = "Datatrac",
//     ACCLAIM = "Acclaim",
//     TRISTAR = "Tristar",
//     TRISTAR_FDS = "Tristar FDS",
//     TRISTAR_FLI = "Tristar FLI",
//     TRISTAR_FLI_CG = "Tristar FLI CG",
// }

const ORDER_DIVISIONS: Array<any> = [
    {description: "Court & Process", value: Division.DATATRAC, checked: false, control: "courtAndProcess"},
    {description: "Depositions", value: Division.ACCLAIM, checked: false, control: "depositions" },
    {description: "Digital", value: Division.TRISTAR_FDS, checked: false, control: "digital"},
    {description: "Investigations", value: Division.TRISTAR_FLI, checked: false, control: "investigations"},
    // {description: "Investigations (CaseGator)", value: Vendor.TRISTAR_FLI_CG, checked: false, control: "courtAndProcess"},
    {description: "Records", value: Division.TRISTAR, checked: false, control: "records"},
    {description: "Discovery", value: Division.EDISCOVERY, checked: false, control: "eDiscovery"}
];

const INCLUDE_DRAFTS = {description: "Include Draft Orders", value: OrderStatus.DRAFT, checked: false, control: "includeDrafts"};

const DEFAULT_SEARCH = {
    corpId: '',
    placedByEmail: '',
    requestedBy: '',
    orderNumber: '',
    clientMatterNumber: '',
    caseNumber: '',
    displayStatus: '',
    includeDrafts: false,
    startOrderDate: null,
    endOrderDate: null,
    courtAndProcess: false,
    depositions: false,
    digital: false,
    investigations: false,
    records: false,
    eDiscovery: false
};

@Component({
    // selector: 'orderTable',
    templateUrl: './list.html',
    styleUrls: ['./list.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0'})),
            state('expanded', style({height: '*'})),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
        trigger('filterExpand', [
            state('collapsed', style({width: '0px', minWidth: '0'})),
            state('expanded', style({width: '*'})),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ])
    ],
})
export class OrderList extends PagedResourceListComponent<Order> {

    @ViewChild(MatSort) sort?: MatSort;
    @ViewChild('filter') filterPane: ResourceListPane = new ResourceListPane();

    private destroy$: Subject<void> = new Subject<void>();

    private setCollectedDocuments$: BehaviorSubject<Order | undefined> = new BehaviorSubject<Order | undefined>(undefined);
    private search$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private serviceAddress$: BehaviorSubject<Order | undefined> = new BehaviorSubject<Order | undefined>(undefined);
    private deliveryAddress$: BehaviorSubject<Order | undefined> = new BehaviorSubject<Order | undefined>(undefined);
    private loadOrderDocuments$: BehaviorSubject<Order | undefined> = new BehaviorSubject<Order | undefined>(undefined);
    private SSORedirectDialog$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private telemetryAnnounce$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public filterCollapsed: boolean = sessionStorage.getItem("filterCollapsed") == 'true';
    public loading: boolean = true;

    public filingServices: Service[] = [];
    public filingTypes: ServiceType[] = [];
    public filingCategories: ServiceCategory[] = [];
    public accountId: string = '';
    public sortedData: MatTableDataSource<Order>
    public expandedEntity: Order | null = null;
    // public expandedFilter: Boolean = false;
    public columnsToDisplay = ['expand', 'division', 'requestedBy', 'orderNumber', 'orderDate', 'clientMatterNumber', 'caseNumber', 'displayStatus'];

    public orderDocuments: Array<Document> = [];

    public standardFilters: OrderHistoryUserFilter = {};
    // public orderFilters: OrderHistoryUserFilter = {}; 

    public orderDivisions = ORDER_DIVISIONS;
    public includeDrafts = INCLUDE_DRAFTS;
    
    public collectedDocuments: Map<Order, Document[]> = new Map();


    public WIP : boolean = WIP();
	public recordsRetrievalAccounts: Array<VendorAccount> = [];

    public orderSearchFormGroup: FormGroup = this.fb.group(DEFAULT_SEARCH, {
        validator: [OrderList.createOrderDateRangeValidator]
    });

    constructor(
        public dataSource: SuccessOrderDataSource,
        protected auth: OidcSecurityService,
        public resourceService: Order_Service,
        private userPermissionService: UserPermission_Service,
        private filingServiceService: Service_Service,
        private serviceAddressService: ServiceAddress_Service,
        public sysConfigService: SystemConfig_service,
        protected route: ActivatedRoute,
        protected router: Router,
        protected dialog: MatDialog,
        protected resourceFormService: ResourceFormService,
        protected fb: FormBuilder,
		private breadCrumbService: BreadCrumbService,
        public pageTitleService: Title,
		public telemetryService: Telemetry_Service,
        public vendorAccountService: VendorAccount_Service,
        public userDevicePreferences: UserDevicePreferencesService
    ) {
        super(dataSource, resourceService, dialog, route, router);

        this.pageTitleService.setTitle("FirstConnect - Order History");
        this.filterFormGroup = this.fb.group(DEFAULT_SEARCH, {
            validator: [OrderList.createOrderDateRangeValidator]
        });
        this.filterFormGroup!.patchValue(this.userDevicePreferences.fcFilter)
        Object.keys(this.dataSource.filters).map((key)=>{this.dataSource.filters[key] = this.userDevicePreferences.fcFilter[key]})

        this.sort = new MatSort();
        this.sort.disableClear = true;
        this.sortedData = new MatTableDataSource(this.dataSource.data);
        this.sortedData.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
            if (typeof data[sortHeaderId] === 'string') {
                return data[sortHeaderId].toLocaleLowerCase().trim();
            }
          
            return data[sortHeaderId];
        };

        this.breadCrumbService.breadcrumbs.next([
            { label: 'Orders', url: '/order'},
            { label: 'History' }
        ]);

        this.breadCrumbService.actions.next([
            { label: 'Refresh', action:this.search.bind(this), icon:'refresh'},
            { label: 'New Order', routerLink: "/order/new", isPrimary: true, icon: 'library_add'}
        ]);
    }
    
    sortData(event: any){
        if(this.dataSource.sort){
            this.dataSource.sort.active = event.active
            this.dataSource.sort.direction = event.direction            
        }
        this.dataSource.reload();
    }    

    expandEntity(entity:Order) {
        this.expandedEntity = this.expandedEntity === entity ? null : entity;
        this.loadDocuments(entity);
        this.loadInfo(entity);
    }

    loadDocuments(entity: Order) {
        if (!this.collectedDocuments.has(entity))
            this.setCollectedDocuments$.next(entity);
    }

    loadInfo(entity: Order) {
        let entityType: ServiceType = new ServiceType();
        let entityCategory: ServiceCategory = new ServiceCategory();
        let entityService = this.filingServiceService.services.value.find((currentService)=>{
            let currentCategory = currentService.categories.find((category)=>{
                let type = category.types.find((type)=>{
                    return type.uuid == entity.filingServiceType_uuid;
                })
                if(type)
                    entityType = type;
                return !!type;
            })
            if(currentCategory)
                entityCategory = currentCategory.category;
            return !!currentCategory;
        })
        if(!entity.deliveryAddress){
            if(entity.delivery_ServiceAddress_uuid){
                this.serviceAddress$.next(entity);
            } else {
                this.deliveryAddress$.next(entity);
            }
        }
    }

    listOrderDocuments(entity:Order) {
        this.loadOrderDocuments$.next(entity);
    }

    clearFilters(search?: boolean) {
        this.filterFormGroup?.reset(DEFAULT_SEARCH);
        if(this.standardFilters.byUser)
            this.filterFormGroup?.controls['placedByEmail'].setValue(this.standardFilters.placedByEmail)
        else
            this.filterFormGroup?.controls['corpId'].setValue(this.standardFilters.corpId)

        if(search)
            this.search();
    }

    getErrors(formControlName: string) {
        const errorMessages : {[key:string]:string} = {
            orderDateRange: "Start date is after end date",
            missingOrderStart: "Start date is required for range"
        };

        let errorMessage : string = '';
        
        Object.keys(this.filterFormGroup?.get(formControlName)?.errors || {})?.forEach((error:string) => {
            if(errorMessages[error]) {
                errorMessage = errorMessages[error];
            }
        });

        return errorMessage;
    }

    static createOrderDateRangeValidator(form: FormGroup) {
        const start = form.get('startOrderDate');
        const end = form.get('endOrderDate');

        if (start && start.value) start.value.setHours(0, 0, 0, 0);
        if (end && end.value) end.value.setHours(23, 59, 59, 999);

        if(start && !start.value && end?.value) {
            start.setErrors({missingOrderStart: true});
            return {missingOrderStart: true};
        }

        if(start && start.value && end && end.value) {
            const isRangeValid = (end.value.getTime() - start.value.getTime() > 0);

            start.setErrors(isRangeValid ? null : {orderDateRange:true});
            return isRangeValid ? null : {orderDateRange:true};
        }

        start?.setErrors(null);
        return null;
    }

    private divisionHelper(control: AbstractControl, vendor: string) {
        if(this.filterFormGroup && !this.filterFormGroup.controls['division']) {
            // division is not declared
            if(control.value) {
                // box is checked, array does not exist => create array with vendor
                this.filterFormGroup.addControl('division', new FormControl([vendor]))
            } 
            // else { 
                // box is not checked, array does not exist => do nothing 
            // }
        } else if(this.filterFormGroup) {
            if(this.filterFormGroup.controls['division'].value == null)
                this.filterFormGroup.controls['division'].setValue([]);
            // find the index for vendor
            let divisions: string[] = this.filterFormGroup.controls['division'].value ? this.filterFormGroup.controls['division'].value : []
            const index = divisions.findIndex((vendorName: string) => vendor == vendorName);    
            if(control.value && index == -1) {
                divisions.push(vendor);
                // box is checked, vendor not found in array => add vendor 
                this.filterFormGroup.controls['division'].setValue(divisions);
            // else if(control?.value && index > -1) {
                // box is checked, vendor found in array =>  do nothing
            
            } else if(!control.value && index > -1) {
                divisions.splice(index,1);
                // box is not checked, vendor found in array => remove vendor
                this.filterFormGroup.controls['division'].setValue(divisions);
            } 
            // } else {
                // box is not checked, vendor not found in array => do nothing
            // }
        } 

    }

    updateOrderFilters() {
        if(!this.dataSource.filters || Object.keys(this.dataSource.filters).length === 0){
            if(this.userPermissionService.canDo(SuccessAccountPermissionNodeName.view_orders_for_firm_accounts)) {
                this.standardFilters = {
                    corpId: this.userPermissionService.loggedInUser?.corpId,
                    byCorp: true
                };
                this.filterFormGroup?.controls['corpId'].setValue(this.userPermissionService.loggedInUser?.corpId)
            } else {
                this.standardFilters = {
                    placedByEmail: this.userPermissionService.loggedInUser?.email,
                    byUser: true
                };
                this.filterFormGroup?.controls['placedByEmail'].setValue(this.userPermissionService.loggedInUser?.email)
            }
        }
        Object.keys(this.filterFormGroup!.controls).map((controlName) => {
            const control = this.filterFormGroup!.get(controlName);

            switch(controlName) {
                case "requestedBy":
                case "orderNumber":
                case "clientMatterNumber":
                case "caseNumber":
                case "displayStatus":
                    break;
                case "includeDrafts":
                    if(control?.value) {
                        this.filterFormGroup!.controls['orderStatus'] ? 
                            this.filterFormGroup!.controls['orderStatus'].setValue(OrderStatus.STUB) :
                            this.filterFormGroup!.addControl('orderStatus', new FormControl(OrderStatus.STUB));
                        this.filterFormGroup!.controls['negateOrderStatusMatch'] ?
                            this.filterFormGroup!.controls['negateOrderStatusMatch'].setValue(true) :
                            this.filterFormGroup!.addControl('negateOrderStatusMatch', new FormControl(true));                        ;

                    } else {
                        this.filterFormGroup!.controls['orderStatus'] ? 
                            this.filterFormGroup!.controls['orderStatus'].setValue([OrderStatus.DRAFT,OrderStatus.STUB]) :
                            this.filterFormGroup!.addControl('orderStatus', new FormControl([OrderStatus.DRAFT,OrderStatus.STUB]));
                        this.filterFormGroup!.controls['negateOrderStatusMatch'] ?
                            this.filterFormGroup!.controls['negateOrderStatusMatch'].setValue(true) :
                            this.filterFormGroup!.addControl('negateOrderStatusMatch', new FormControl(true));                        ;
                    }
                    break;
                case "courtAndProcess":
                    if(control)
                        this.divisionHelper(control, Division.DATATRAC)
                    break;
                case "depositions":
                    if(control)
                        this.divisionHelper(control, Division.ACCLAIM)
                    break;
                case "digital":
                    if(control)
                        this.divisionHelper(control, Division.TRISTAR_FDS)
                    break;
                case "investigations":
                    if(control) {
                        // investigations has two vendors, so we add/remove both as needed
                        this.divisionHelper(control, Division.TRISTAR_FLI);
                        this.divisionHelper(control, Division.TRISTAR_FLI_CG);
                    }
                    break;
                case "records":
                    if(control)
                        this.divisionHelper(control, Division.TRISTAR);
                    break;
                case "eDiscovery":
                    if(control)
                        this.divisionHelper(control, Division.EDISCOVERY);
                    break;
                case "startOrderDate":
                    if(control?.pristine && !control?.value) {
                        // likely the result of search run after clear
                        // delete this.orderFilters.orderDate;
                    }
                    else if(control?.dirty && control?.value) {
                        let startDate : Date = control?.value;

                        // strip out the time part of the date.
                        startDate.setHours(0, 0, 0, 0);
                    }
                    break;
                case "endOrderDate": 
                    if(control?.dirty && control?.value) {

                        let endDate : Date = control?.value;

                        // strip out the time part of the date.
                        endDate.setHours(0, 0, 0, 0);
                        let previousDate = new Date(endDate); 
                        previousDate.setDate(previousDate.getDate() - 1); 
                    } 
                    // else do nothing to the orderFilters, because we might have valid data in the array 
                    break;
            }
        });
    }
    
    pageChange(event:any){
        this.updateOrderFilters();
        this.dataSource.filters = {}
        Object.keys(this.filterFormGroup!.controls).map((control)=>{
            let filter : {[key:string]:any} = {[control]: this.filterFormGroup?.controls[control].value}
            Object.assign(this.dataSource.filters, filter)
        })
    }
    
    search(){
        // make sure form is valid before searching
        if(this.filterFormGroup!.invalid) return;
        if(this.filterFormGroup!.controls['corpId'] && this.filterFormGroup!.controls['placedByEmail']){
            if(this.userPermissionService.canDo(SuccessAccountPermissionNodeName.view_orders_for_firm_accounts)) {
                this.standardFilters = {
                    corpId: this.userPermissionService.loggedInUser?.corpId,
                    byCorp: true
                };
                this.filterFormGroup?.controls['corpId'].setValue(this.userPermissionService.loggedInUser?.corpId)
            } else {
                this.standardFilters = {
                    placedByEmail: this.userPermissionService.loggedInUser?.email,
                    byUser: true
                };
                this.filterFormGroup?.controls['placedByEmail'].setValue(this.userPermissionService.loggedInUser?.email)
            }
        }
        this.updateOrderFilters();

		const orderDate: Date[] = [];
		Object.keys(this.filterFormGroup!.controls).map((control) => {
			if (control == "startOrderDate" || control == "endOrderDate") {
				if (control == "startOrderDate" && this.filterFormGroup?.controls[control].value) {
					orderDate[0] =
						this.filterFormGroup.controls[control].value;
					orderDate[0].setHours(0, 0, 0, 0);
				} else if (control == "endOrderDate" && this.filterFormGroup?.controls[control].value) {
					orderDate[1] =
						this.filterFormGroup.controls[control].value;
					orderDate[1].setHours(23, 59, 59, 999);
				}
			} else {
				const filter: { [key: string]: any } = {
					[control]: this.filterFormGroup?.controls[control].value,
				};
				Object.assign(this.dataSource.filters, filter);
			}
		});
		if (orderDate.length > 0)
			Object.assign(this.dataSource.filters, { orderDate: orderDate });
        else if (this.dataSource.filters['orderDate'])
            delete this.dataSource.filters['orderDate'];

        this.filterFormGroup!.disable();
        // this.onFilterSubmit();
        this.dataSource.reload();
        this.filterFormGroup!.enable();
    }

    getDivisionSrc(division: string){

        switch(division)
        {
            case 'Digital':
                return "/assets/images/FLNDivisionDigital.png"
            case 'Investigations':
                return "/assets/images/FLNDivisionInvestigations.png"
            case 'Records':
                return "/assets/images/FLNDivisionRecords.png"
            case 'Court & Process':
                return "/assets/images/FLNDivisionCourtProcess.png"
            case 'Depositions':
                return "/assets/images/FLNDivisionDepositions.png"
            case 'Discovery':
                return "/assets/images/FLNDivisionDiscovery.png"
        }
        return '';
    }

    setDivisionInfo(entity: Order){
        let entityType: ServiceType = new ServiceType();
        let entityCategory: ServiceCategory = new ServiceCategory();
        let entityService = this.filingServiceService.services.value.find((currentService)=>{
            let currentCategory = currentService.categories.find((category)=>{
                let type = category.types.find((type)=>{
                    return type.uuid == entity.filingServiceType_uuid;
                })
                if(type){
                    entityType = type;
                }
                return !!type;
            })
            if(currentCategory){
                entityCategory = currentCategory.category;
            }
            return !!currentCategory;
        })
        if(entityType.name && entityCategory.name){
            entity.divisionExtended = (entityCategory.parentCategory ? entityCategory.parentCategory : entityCategory.name) + ": " + entityType.displayName;
            return entity.divisionExtended;
        }
        entity.divisionExtended = ' ';
        return entity.divisionExtended;
    }

    getDateUTC(s: number, entity : any)
    {
        let o = new Order(entity);
        switch(s)
        {
            case 1:
                return o.orderDateUTC;
            case 2:
                return o.jobDateUTC;
            case 3:
                return o.dueDateUTC;
            case 4:
                return o.updatedAtUTC;
        }
        return null;
    }

    allowSSO(entity: any) {
        return entity.division == 'Records';
    }

    SSORedirect() {
        if(!this.userPermissionService.loggedInUser)
            return;

        this.SSORedirectDialog$.next(true);
    }

    private addressSubs() {
        this.serviceAddress$
			.pipe(
				filter((entity) => !!entity),
				switchMap((entity) =>
					this.serviceAddressService
						.get(entity!.delivery_ServiceAddress_uuid!)
						.pipe(map((res) => ({ entity, res })))
				),
				takeUntil(this.destroy$)
			)
			.subscribe(({ entity, res }) => {
				let address = res;
				entity!.deliveryLocation = address.name;
				entity!.deliveryAddress =
					(address.address || " ") +
					" " +
					(address.city || " ") +
					" " +
					(address.state || " ") +
					" " +
					(address.zip || " ");
			});

		this.deliveryAddress$
			.pipe(
				filter((entity) => !!entity),
				switchMap((entity) =>
					this.serviceAddressService
						.getDeliveryAddressesByOrderId(entity!.uuid)
						.pipe(map((res) => ({ entity, res })))
				),
				takeUntil(this.destroy$)
			)
			.subscribe(({ entity, res }) => {
				let address = res[0] || new ServiceAddress();
				entity!.deliveryLocation = address.name;
				entity!.deliveryAddress =
					(address.address || " ") +
					" " +
					(address.city || " ") +
					" " +
					(address.state || " ") +
					" " +
					(address.zip || " ");
			});
    }

    private docsSubs() {
        this.setCollectedDocuments$
			.pipe(
				filter((order) => !!order),
				switchMap((entity) =>
					this.resourceService
						.findDocumentsByOrderId(entity!.uuid)
						.pipe(map((docs) => ({ entity: entity!, docs })))
				),
				takeUntil(this.destroy$)
			)
			.subscribe(({ entity, docs }) =>
				this.collectedDocuments.set(entity!, docs)
			);

		this.loadOrderDocuments$
			.pipe(
				filter((entity) => !!entity),
				switchMap((entity) =>
					this.resourceService.findDocumentsByOrderId(entity!.uuid)
				),
				takeUntil(this.destroy$)
			)
			.subscribe((docs) => (this.orderDocuments = docs));
    }

    private SSORedirectSubs() {
        this.SSORedirectDialog$.pipe(
			filter((show) => !!show),
			switchMap(() =>
				this.dialog
					.open(SelectVendorAccountDialog, {
						data: {
							vendor: this.vendorAccountService.vendorName
								.RecordsRetrieval,
							accounts: this.recordsRetrievalAccounts,
						},
					})
					.afterClosed()
			),
			takeUntil(this.destroy$)
		).subscribe((vendorAccount) => {
			//redirect logic
			if (!vendorAccount) return;

			this.telemetryAnnounce$.next(true);

			window.open(environment.config["TristarLoginUrl"], "_blank");
		});

		this.telemetryAnnounce$
			.pipe(
				filter((announce) => !!announce),
				switchMap(() =>
					this.telemetryService.announce(
						TelemetryEventType.recordsSSO,
						this.router.url,
						this.userPermissionService.loggedInUser
					)
				),
				takeUntil(this.destroy$)
			)
			.subscribe();
    }

    ngOnInit() {
        super.ngOnInit();

		if (this.sysConfigService.maintenanceRedirectCheck()) {
			window.localStorage.removeItem("loggedInUserPermissionNodes");
			this.auth.logoff();
		}

		if (this.sort) {
			this.dataSource.sort = this.sort;
			this.dataSource.pageSize = 25;
		}

		this.dataSource.loading
			.pipe(takeUntil(this.destroy$))
			.subscribe((load) => {
				this.loading = load;
                document.getElementById("filterPaneOrder")!.click();
			});

		this.filterFormGroup = this.fb.group(DEFAULT_SEARCH, {
			validator: [OrderList.createOrderDateRangeValidator],
		});
        this.filterFormGroup.patchValue(this.userDevicePreferences.fcFilter)

		this.addressSubs();
		this.docsSubs();
		this.SSORedirectSubs();

		this.auth.isAuthenticated$
			.pipe(
				filter((authenticated) => !!authenticated),
				switchMap(() => this.userPermissionService.userSync),
				filter((userSynced) => !!userSynced),
				switchMap(() => {
					if (!this.userPermissionService.loggedInUser) return of([]);
					return this.vendorAccountService.getVendorAccountsByUsernameAndVendor(
						{
							username:
								this.userPermissionService.loggedInUser
									?.username,
							vendorName:
								this.vendorAccountService.vendorName.TRISTAR,
						}
					);
				}),
				takeUntil(this.destroy$)
			)
			.subscribe((result) => {
				console.debug(
					"siteFrame: recordsRetrievalAccounts:",
					this.recordsRetrievalAccounts
				);
				this.recordsRetrievalAccounts = result;
			});

		this.search$
			.pipe(
				filter((search) => !!search),
				switchMap(() => this.userPermissionService.loggedInUser$),
				filter((user) => !!user),
				takeUntil(this.destroy$)
			)
			.subscribe(() => this.search());
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
		setTimeout(() => {
			if (!this.filterFormGroup) {
				this.filterFormGroup = this.fb.group(DEFAULT_SEARCH, {
					validator: [OrderList.createOrderDateRangeValidator],
				});
			}

            this.filterFormGroup!.patchValue({
                startOrderDate: this.userDevicePreferences.fcFilter?.orderDate ? this.userDevicePreferences.fcFilter.orderDate[0] : null,
                endOrderDate: this.userDevicePreferences.fcFilter?.orderDate ? this.userDevicePreferences.fcFilter.orderDate[1] : null
            })

			this.filterFormGroup!.valueChanges.pipe(
				takeUntil(this.destroy$)
			).subscribe((jsonObject) => {
                const { startOrderDate, endOrderDate } = jsonObject;
                delete jsonObject.startOrderDate;
                delete jsonObject.endOrderDate;
                jsonObject.orderDate = [ startOrderDate, endOrderDate ];
				this.userDevicePreferences.fcFilter = jsonObject;
			});

			this.filterFormGroup.disable();

			this.auth.isAuthenticated$
				.pipe(
					filter((authenticated) => !!authenticated),
					switchMap(() => this.userPermissionService.userSync),
					filter((userSynced) => !!userSynced),
					takeUntil(this.destroy$)
				)
				.subscribe(() => {
					if (
						this.userPermissionService.canDo(
							SuccessAccountPermissionNodeName.view_orders_for_firm_accounts
						)
					) {
						this.standardFilters = {
							corpId: this.userPermissionService.loggedInUser
								?.corpId,
							byCorp: true,
						};
						this.filterFormGroup?.controls["corpId"].setValue(
							this.userPermissionService.loggedInUser?.corpId
						);
					} else {
						this.standardFilters = {
							placedByEmail:
								this.userPermissionService.loggedInUser?.email,
							byUser: true,
						};
						this.filterFormGroup?.controls[
							"placedByEmail"
						].setValue(
							this.userPermissionService.loggedInUser?.email
						);
					}

					// this.orderFilters = this.standardFilters;
					let filterClick =
						document.getElementById("filterPaneOrder");
					if (
						filterClick &&
						!filterClick.hasAttribute("filterClickAttached")
					) {
						this.filterPaneClick(filterClick, this.filterPane);
					}

					this.search$.next(true);
				});
		});
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
